import { Ref, useEffect, useRef } from "react";

// A hook to use the ref from forwardRef
// Based on https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
// and https://gist.github.com/pie6k/b4717f392d773a71f67e110b42927fea
export default function useShareForwardedRef<T>(forwardedRef: Ref<T>) {
  // final ref that will share value with forward ref. this is the one we will attach to components
  const innerRef = useRef<T>(null);

  useEffect(() => {
    // after every render - try to share current ref value with forwarded ref
    if (!forwardedRef) {
      return;
    }
    if (typeof forwardedRef === "function") {
      forwardedRef(innerRef.current);
    } else {
      // current is readonly so we need to cast to any for reassignment
      // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-explicit-any
      (forwardedRef as any).current = innerRef.current;
    }
  });

  return innerRef;
}
